<template>
  <div class="main-content">
    <second-nav-bar></second-nav-bar>
    <div class="content">
      <div class="header">
        <span>校务管理 / 电子章管理</span>
      </div>
      <div class="table-container scroll">
        <div style="height: 250px;">
          <div class="left-seal">
            <p class="seal-title">学校印章</p>
            <div style="margin-top: 30px;">
              <span class="label">电子章图片</span>
              <el-upload
                v-loading="loading[0]"
                class="avatar-uploader"
                action="/acc/school/seals"
                accept="image/png, image/jpeg"
                :data="{ type: 1 }"
                :headers="myHeaders"
                :show-file-list="false"
                :on-success="(res, file) => handleAvatarSuccess(res, file, 0)"
                :before-upload="(f) => beforeAvatarUpload(f, 0)"
                :on-error="() => uploadError(0)"
              >
                <div class="el-upload__tip" slot="tip">建议图片大小140*140，jpg、png格式，不超过500kb</div>
                <img
                  v-if="fileUrl(1).t2"
                  :src="fileUrl(1).t2"
                  class="avatar"
                  @mouseenter="hover(0)"
                  @mouseleave="leave(0)"
                />
                <div v-if="fileUrl(1).t2 && mouseHover[0]" class="avatar select">
                  <span style="color: #FFF; font-size: 16px;">修改</span>
                  <span style="color: #FFF; font-size: 16px; cursor: pointer" @click="(event) => removeSeal(event, 1)">清除</span>
                </div>
                <i v-else-if="!fileUrl(1).t2" class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div class="right-seal">
            <p class="seal-title">校长印章</p>
            <div style="margin-top: 30px;">
              <span class="label">电子章图片</span>
              <el-upload
                v-loading="loading[1]"
                class="avatar-uploader"
                action="/acc/school/seals"
                accept="image/png, image/jpeg"
                :data="{ type: 2 }"
                :headers="myHeaders"
                :show-file-list="false"
                :on-success="(res, file) => handleAvatarSuccess(res, file, 1)"
                :before-upload="(f) => beforeAvatarUpload(f, 1)"
                :on-error="() => uploadError(1)"
              >
                <div class="el-upload__tip" slot="tip">建议图片大小140*140，jpg、png格式，不超过500kb</div>
                <img
                  v-if="fileUrl(2).t2"
                  :src="fileUrl(2).t2"
                  :style="imageUrl[1] ? '' : 'opcacity: 0'"
                  class="avatar"
                  @mouseenter="hover(1)"
                  @mouseleave="leave(1)"
                />
                <div v-if="fileUrl(2).t2 && mouseHover[1]" class="avatar select">
                  <span style="color: #FFF; font-size: 16px;">修改</span>
                  <span style="color: #FFF; font-size: 16px; cursor: pointer" @click="(event) => removeSeal(event, 2)">清除</span>
                </div>
                <i v-else-if="!fileUrl(2).t2" class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
        </div>
        <div style="height: 250px; margin-top: 20px;">
          <div class="left-seal">
            <p class="seal-title">教导主任</p>
            <div style="margin-top: 30px;">
              <span class="label">电子章图片</span>
              <el-upload
                v-loading="loading[2]"
                class="avatar-uploader"
                action="/acc/school/seals"
                accept="image/png, image/jpeg"
                :data="{ type: 3 }"
                :headers="myHeaders"
                :show-file-list="false"
                :on-success="(res, file) => handleAvatarSuccess(res, file, 2)"
                :before-upload="(f) => beforeAvatarUpload(f, 2)"
                :on-error="() => uploadError(2)"
              >
                <div class="el-upload__tip" slot="tip">建议图片大小140*140，jpg、png格式，不超过500kb</div>
                <img
                  v-if="fileUrl(3).t2"
                  :src="fileUrl(3).t2"
                  class="avatar"
                  @mouseenter="hover(2)"
                  @mouseleave="leave(2)"
                />
                <div v-if="fileUrl(3).t2 && mouseHover[2]" class="avatar select">
                  <span style="color: #FFF; font-size: 16px;">修改</span>
                  <span style="color: #FFF; font-size: 16px; cursor: pointer" @click="(event) => removeSeal(event, 3)">清除</span>
                </div>
                <i v-else-if="!fileUrl(3).t2" class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div class="right-seal">
            <p class="seal-title">德育主任</p>
            <div style="margin-top: 30px;">
              <span class="label">电子章图片</span>
              <el-upload
                v-loading="loading[3]"
                class="avatar-uploader"
                action="/acc/school/seals"
                accept="image/png, image/jpeg"
                :data="{ type: 4 }"
                :headers="myHeaders"
                :show-file-list="false"
                :on-success="(res, file) => handleAvatarSuccess(res, file, 3)"
                :before-upload="(f) => beforeAvatarUpload(f, 3)"
                :on-error="() => uploadError(3)"
              >
                <div class="el-upload__tip" slot="tip">建议图片大小140*140，jpg、png格式，不超过500kb</div>
                <img
                  v-if="fileUrl(4).t2"
                  :src="fileUrl(4).t2"
                  class="avatar"
                  @mouseenter="hover(3)"
                  @mouseleave="leave(3)"
                />
                <div v-if="fileUrl(4).t2 && mouseHover[3]" class="avatar select">
                  <span style="color: #FFF; font-size: 16px;">修改</span>
                  <span style="color: #FFF; font-size: 16px; cursor: pointer" @click="(event) => removeSeal(event, 4)">清除</span>
                </div>
                <i v-else-if="!fileUrl(4).t2" class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import SecondNavBar from '@/components/common/SecondNavBar'
export default {
  props: [],

  components: {
    'second-nav-bar': SecondNavBar
  },

  data () {
    var token = localStorage.getItem('token')
    return {
      imageUrl: [],
      mouseHover: [false, false, false, false],
      loading: [false, false, false, false],
      myHeaders: { Authorization: 'Bearer ' + token }
    }
  },

  watch: {

  },

  computed: {
  },

  mounted () {
    this.initSeal()
  },

  methods: {
    uploadError (index) {
      this.loading[index] = false
    },
    initSeal () {
      this.$xhrGet(`/acc/school/seals`).then(rs => {
        this.imageUrl = rs.data
      })
    },

    fileUrl (index) {
      let file = _.filter(this.imageUrl, { t1: index })
      if (file.length > 0) {
        return file[0]
      } else {
        return {t2: ''}
      }
    },

    handleAvatarSuccess (res, file, index) {
      this.loading[index] = false
      if (res.code === 'SUCCESS') {
        this.initSeal()
      } else if (res.code === 'empty_file') {
        this.$message.error('图片为空文件')
      } else if (res.code === 'file_too_large') {
        this.$message.error('图片过大')
      } else if (res.code === 'empty_fileName') {
        this.$message.error('图片名为空')
      } else if (res.code === 'file_type_error') {
        this.$message.error('上传图片只能是 JPG或者PNG 格式')
      }
    },

    beforeAvatarUpload (file, index) {
      let type = file.name.split('.')[1]
      const isJPG = (type === 'jpeg' || 'jpg' || 'png')
      const isLt500KB = file.size / 1024 < 500
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG或者PNG 格式')
      }
      if (!isLt500KB) {
        this.$message.error('仅支持上传500kb以下图片')
      }
      if (isJPG && isLt500KB) this.loading[index] = true
      return isJPG && isLt500KB
    },

    hover (index) {
      this.$set(this.mouseHover, index, true)
    },

    removeSeal (event, type) {
      event.stopPropagation()
      let param = { type }
      this.$xhrDelete(`/acc/school/seals`, { params: param }).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.initSeal(this.schoolTermId)
        }
      })
    },

    leave: _.debounce(function (index) {
      for (let ind = 0; ind < this.mouseHover.length; ind++) {
        if (ind !== index) {
          this.$set(this.mouseHover, ind, false)
        }
      }
      this.$set(this.mouseHover, index, false)
    }, 800)
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  width: 100%;
  height: 100%;
  position: relative;
  background: var(--theme-background);
}
.content {
  float: right;
  height: 100%;
  width: calc(100% - 200px);
}
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  background: #ffffff;
  border-bottom: tranparent;
  box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.12);
}
.header span {
  font-size: 14px;
  color: #757575;
  margin-left: 20px;
}
.table-container {
  width: calc(100% - 40px);
  max-height: calc(100% - 84px);
  overflow: auto;
  margin: 20px;
}
/deep/ .el-input__inner {
  height: 36px;
}
/deep/ .el-button--primary.is-plain {
  background: transparent;
}
.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  color: var(--theme-color);
  background: transparent;
}
.left-seal {
  float: left;
  width: calc(100% / 2 - 50px);
  padding: 20px;
  border-radius: 4px;
  background: #fff;
}
.right-seal {
  float: left;
  width: calc(100% / 2 - 50px);
  margin-left: 20px;
  padding: 20px;
  border-radius: 4px;
  background: #fff;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px solid #dce5f4;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #5e93f6;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 140px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}
.avatar-uploader {
  display: inline-block;
  margin-left: 10px;
}
.avatar {
  width: 140px;
  height: 140px;
  display: block;
}
.el-upload__tip {
  font-size: 14px;
  color: #757575;
}
.seal-title {
  font-size: 16px;
  font-weight: 500;
  color: #444444;
}
.label {
  vertical-align: top;
  font-size: 14px;
  color: #444;
}
.select {
  position: absolute;
  top: 0;
  background: #000;
  opacity: 0.6;
  line-height: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/school-admin/affair/SealManage.vue